import { IACDLEvent } from '../../../__legacy__/services/eventBus.service';
import { Alert } from './Alert';

export const AlertsUpdatedEventType = Symbol('ALERTS_UPDATED_EVENT');

export class AlertsUpdatedEvent implements IACDLEvent {
  constructor(public readonly alerts: Alert[]) {}

  readonly type: symbol = AlertsUpdatedEventType;
}
